import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comment-ca-marche',
  templateUrl: './comment-ca-marche.component.html',
  styleUrls: ['./comment-ca-marche.component.scss']
})
export class CommentCaMarcheComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
